<template>
  <div>
    <title>微门店用户</title>
    <section class="mainPart">
      <!--S 公用头部切换-->
      <!-- <CompanyTab :active="currentTit"></CompanyTab> -->
      <!--E 公用头部切换-->
      <!--S 检索-->
      <el-form :inline="true" :model="distributeForm" class="searchForm" @submit.native.prevent>
          <el-form-item label="关键词">
              <el-input clearable v-model="distributeForm.flowname" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" @click="querySearch">查询</el-button>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" plain @click="getShowDepotDlog('add')">新增</el-button>
          </el-form-item>
          <em class="iconbulb breathTit" v-if="creappnum != 0">最多可创建<i class="redColor">{{creappnum}}</i>个微门店</em>
      </el-form>
      <!--E 检索-->
      <!-- S 列表 -->
      <div class="gsListTable individualiz">
        <el-form :model="searchGLForm" inline size="medium">
          <!-- <el-form-item class="borderline">
            <em class="greyColor">展示顺序</em>
            <el-checkbox-group v-model="searchGLForm.sortway" @change="sortwayChange">
              <el-checkbox label="0">降序</el-checkbox>
              <el-checkbox label="1">升序</el-checkbox>
            </el-checkbox-group>
          </el-form-item> -->
          <el-form-item class="borderline" v-if="ElementControls('erjimendian')==1">
            <em class="greyColor"></em>
            <el-checkbox v-model="searchGLForm.isbindstore" :true-label="1" :false-label="''" @change="querySearch">已绑定当前门店</el-checkbox>
          </el-form-item>
          <el-form-item class="borderline borderNone">
            <em class="greyColor">状态</em>
            <el-checkbox-group v-model="searchGLForm.status" @change="statusChange">
              <el-checkbox label="1">启用</el-checkbox>
              <el-checkbox label="0">禁用</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          
        </el-form>
        <el-table class="comTable orderTable" ref="gsTable" :data="payRecordList" border :maxHeight="tableHeight" v-loading="isLoad">
          <el-table-column label="序号" type="index" fixed></el-table-column>
          <el-table-column label="微门店名称" sortable prop="flowname" fixed min-width="230">
            <template slot-scope="scope">
              <p class="textFl" :title="scope.row.flowname">{{scope.row.flowname?scope.row.flowname:'--'}}</p>
              <small class="textFl" v-if="ElementControls('erjimendian')==1 && scope.row.deliverystorename" :title="scope.row.deliverystorename">发货门店：{{scope.row.deliverystorename}}</small>
            </template>
          </el-table-column>
          <el-table-column label="是否绑定微信" min-width="150">
            <template slot-scope="scope">
              <el-tag type="success" plain v-if="scope.row.openid">已绑微信</el-tag>
              <el-tag type="info" plain v-else>未绑微信</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="已绑定门店" min-width="180" v-if="ElementControls('erjimendian')==1">
            <template slot-scope="scope">
              <span v-if="scope.row.bindwstorenumber && scope.row.bindwstorenumber>0" class="iconhand cityName" @click="viewBindStore(scope.row)"><b>{{ scope.row.bindwstorenumber }}</b></span>
              <span v-else class="nohandNum">{{ scope.row.bindwstorenumber }}</span>
              <p v-if="scope.row.cardpower || scope.row.orderpower || (scope.row.exppower && scope.row.deliverystorename)">
                <el-tag type="warning" plain v-if="scope.row.cardpower">可激活</el-tag>
                <el-tag type="danger" plain v-if="scope.row.orderpower">可核销</el-tag>
                <el-tag type="primary" plain v-if="scope.row.exppower && scope.row.deliverystorename">可发货</el-tag>
              </p>
            </template>
          </el-table-column>
          <el-table-column label="联系人" min-width="180">
            <template slot-scope="scope">
              <div class="linkWrap">
                <p class="textFl iconuser" :title="scope.row.linkman">{{scope.row.linkman || '--'}}</p>
                <p class="linkNum">
                  <b v-show="scope.row.mobile" class="iconiPhone" :title="scope.row.mobile">{{scope.row.mobile}}</b>
                  <b v-show="scope.row.tel" class="icongh" :title="scope.row.tel">{{scope.row.tel}}</b>
                </p>
                <span v-if="!scope.row.mobile && !scope.row.tel">--</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="详细地址" min-width="200">
            <template slot-scope="scope">
              <p class="textFl">{{scope.row.province}}{{scope.row.city}}{{scope.row.district}}</p>
              <small class="textFl greyColor" :title="scope.row.addrdet">{{scope.row.addrdet || '--'}}</small>
            </template>
          </el-table-column>
          <!-- <el-table-column label="微信头像/昵称" min-width="115">
            <template slot-scope="scope">
              <div class="flexUpDownCenter wechatAvatar" v-if="scope.row.hpurl">
                <p><img class="imgAlign" :src="scope.row.hpurl ? scope.row.hpurl : 'https://presale.jhtsoft.com/picms/c47519dc61feb.png'"></p>
                <span>{{scope.row.nickname}}</span>
              </div>
              <span v-else>--</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column label="展示顺序" width="100" sortable prop="showpos">
            <template slot-scope="scope">
              <span class="commonNum">{{scope.row.showpos}}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="状态" min-width="100">
            <template slot-scope="scope">
              <el-switch :value="scope.row.status? true : false" @change="handleStatus(scope.row,scope.row.status)" :width="45" class="isSwitch" :active-text="scope.row.status?'启':'禁'"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160" fixed="right">
              <template slot-scope="scope">
                  <p class="handle">
                    <span title="详情" @click="getShowDepotDlog('detail',scope.row.flowcode)"><i class="icondetails"></i></span>
                    <span title="编辑" @click="getShowDepotDlog('edit',scope.row.flowcode)"><i class="iconedit"></i></span>
                    <span title="绑定微信" @click="getShowWechat(scope.row.flowcode)" v-if="!scope.row.openid"><i class="iconwx"></i></span>
                    <span title="解绑微信" @click="getShowRemoveWechat(scope.row.flowcode)" v-if="scope.row.openid"><i class="iconjb"></i></span>
                  </p>
              </template>
          </el-table-column>
          <template slot="empty" v-if="isLoad">
              <div :class="{noData:isLoad}"></div>
          </template>
          <template slot="empty" v-else>
            <div class="noData"><span>暂无数据</span></div>
          </template>
        </el-table>
      </div>
      <!-- E 列表 -->
      <!-- S 分页 -->
      <Page :pageTotal="pagebean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
      <!-- E 分页 -->
     <!-- S 绑定微信弹框 -->
     <el-dialog class="comDlog recoverDlog wechatDlog" title="提示" :visible.sync="wechatDialogVisible" :before-close="getCloseWechat" append-to-body :close-on-click-modal="false">
        <div class="imgCon" v-loading="isCodeLoad">
            <img :src="subQrcode ? subQrcode :'http://presale.jhtsoft.com/picms/c47499b67d489.png'" class="imgAlign">
            <div class="cover" v-if="isRefresh">
                <span @click="getShowWechat">点击刷新</span>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="getCloseWechat">关闭</el-button>
        </span>
     </el-dialog>
     <!-- E 绑定微信弹框 -->

    </section>

    <!-- S 查看微门店 -->
    <StoreCheck :storeList="storeList" :currentFlowname="currentFlowname" :objectType="9" :storeCheckDialogVisible="storeCheckDialogVisible" @closeChild="getCheckStoreCld"></StoreCheck>
    <!-- E 查看微门店 -->
  </div>
</template>
<script>
import api from '@/apis/api.js';
import { Message, MessageBox } from "element-ui";
export default {
  name: 'CompanyStore',
  data () {
    return {
      isLoad:false,//加载中
      currentTit:0, //当前选中菜单
      //检索
      distributeForm: {
        flowname: "", //关键词
      },
      searchGLForm: {
        // sortway: [],//顺序
        status: [],//状态
        isbindstore:'',//已绑定一级门店
      },
      payRecordList:[],//列表信息
      tableHeight: window.innerHeight*.8, //表格动态高度
      operate:'',//操作，add:新增，edit:编辑，detail:详情
      pageSize: 30, // 每页展示的条数
      currentPage: 1, // 当前请求的页数
      pagebean: {
          totalnum: 0,
      }, // 获取到的列表分页信息
      wechatDialogVisible:false,//微信绑定弹框
      subQrcode:'',//微信二维码
      creappnum:'',//企业微门店上限
      indexys:0,//二维码刷新计时
      isBindWx:'',//定时器
      flowcode:'',//流向编号
      isCodeLoad:false,//二维码加载状态
      isRefresh:false,//点击刷新二维码
      paths:'',
      payRecordNum: 0, // 企业微门店总数量

      storeList:[],//已选门店对象
      currentFlowname:'',//当前流向名称
      storeCheckDialogVisible:false,
    }
  },
  watch:{
    $route(to,from){
          this.paths = from
      },
  },
  activated(){
    setTimeout(()=>{
      if(this.paths.name=='微门店用户操作'&&this.paths.params.operate!='add'){
            this.getFlowList();
      }else{
          this.distributeForm= {
            flowname: "", //关键词
          };
          this.searchGLForm= {
            // sortway: [],//顺序
            status: [],//状态
            isbindstore:'',
          };
          this.currentPage=1;
          this.getFlowList('total');
      }
    },100)
  },
  components: {
    // CompanyTab: resolve => require(["@/components/ManageFolder/CompanyTab.vue"],resolve), //头部tab组件
    Page: resolve => require(["@/components/common/Page.vue"],resolve),
    StoreCheck: resolve =>require(["@/components/CardsFolder/StoreCheck.vue"], resolve), //查看绑定门店
  },
  methods: {
    //查看已绑定门店
    viewBindStore(row){
      this.currentFlowname = row.flowname;
      this.haveLinkedStores(row.flowcode);
    },
    //获取当前微门店已绑定的门店列表
    haveLinkedStores(flowcode){
      let params = {
        type:1,
        flowcode:flowcode
      };
      api.GETBINDWXFLOW(params).then(res => {
        if(res.data.status == '200'){
          if(res.data.data && res.data.data != 'null'){
            this.storeList = res.data.data;
            this.storeCheckDialogVisible = true;
          }
        }else{
          this.$message.error(res.data.message)
        }
      }).catch()
    },
    // 关闭查看门店弹窗
    getCheckStoreCld() {
      this.storeCheckDialogVisible = false;
    },
    //查询
    querySearch(){
      this.currentPage = 1;
      this.getFlowList();
    },
    // 状态切换
    statusChange(){
      if(this.searchGLForm.status.length > 1) {
          this.searchGLForm.status.splice(0,1)
      }
      this.querySearch();
    },
    // 顺序切换
    // sortwayChange(){
    //   if(this.searchGLForm.sortway.length > 1) {
    //       this.searchGLForm.sortway.splice(0,1)
    //   }
    //   this.currentPage = 1;
    //   this.getFlowList();
    // },
    // 获取列表
    getFlowList(type){
      let params = {
        flowname:this.distributeForm.flowname,
        objtype:4,  //0:门店；1：发货网点；2：一级分销；4：微门店；5.企业微门店；
        isbindstore:this.searchGLForm.isbindstore,//已绑定一级门店
        pageparam:{
          pagesize: this.pageSize, //每页条数
          currentpage: this.currentPage, //当前页数
          isnewcomp: 1 //是否需要重新统计页数
        }
      }
      if(this.searchGLForm.status[0]){
        params.status =  Number(this.searchGLForm.status[0]);
      }
      // if(this.searchGLForm.sortway[0]){
      //   params.sortway =  Number(this.searchGLForm.sortway[0]);
      // }
      this.isLoad = true;
      api.GET_FLOWLIST(params).then((res) => {
        if(res.data.status == '200'){
          this.isLoad = false;
          this.payRecordList = res.data.data;
          if(res.data.pagebean){
            this.pagebean = res.data.pagebean;
            if(type == 'total') {
              this.payRecordNum = res.data.pagebean.totalnum;
            }
          }
        }
      })
    },
    // 接收分页信息
    updatePage(size,num) {
        this.pageSize = size;
        this.currentPage = num;
        this.getFlowList();
    },
    //切换状态
    handleStatus(row,val){
      let valTxt = '';
      let status = 0;
      if(!val){
          valTxt = '启用';
          status = 1;
      }else{
          valTxt = '禁用';
          status = 0;
      }
      MessageBox.confirm(`确定${valTxt}当前企业微门店吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
            ucodes:row.flowcode,
            status:status
        }
        api.UPDATEFLOWSTATUS(params).then((res) => {
            if(res.data.status == '200'){
                this.$message.success(`${valTxt}成功`);
                this.getFlowList()
            }else{
                this.$message.error(res.data.message)
            }
        })
      }).catch(() => {});
    },
    // 打开弹框
    getShowDepotDlog(operate,flowcode){
        if(operate == 'add'){
          if(this.creappnum !=0 && this.payRecordNum >= this.creappnum){
            MessageBox.alert(`企业微门店创建数量已达上限，无法继续创建！`, '提示', {
              confirmButtonText: '关闭',
              type: 'warning'
            }).then(() => {}).catch(() => {});
            return false;
          }
        }
        this.operate = operate;
        this.$router.push({
          name:'微门店用户操作',
          path:'/CompanyStoreOperate',
          params:{
            operate:operate
          },
          query:{
            flowcode:flowcode
          }
        })
    },
    // 绑定微信弹框
    getShowWechat(flowcode){
      this.indexys = 0;
      this.isRefresh = false;
      if(flowcode){
        this.flowcode = flowcode;
      }
      this.isCodeLoad = true;
      api.GET_SUBQRCODE({flowcode:this.flowcode}).then((res) => {
        if(res.data.status == '200'){
          this.isCodeLoad = false;
          if(res.data.data){
            let subdata = res.data.data;
            this.subQrcode = subdata.url;
            // 查询是否绑定微信
            if(!this.isBindWx){
              this.isBindWx = setInterval(()=>{
                this.checkOpenid(subdata.unicode);
              },2000)
            }
          }else{
            this.isRefresh = true;
            this.$message.error('获取二维码信息失败！');
          }
        }else{
          this.isCodeLoad = false;
          this.isRefresh = true;
          this.$message.error(res.data.message)
        }

      })
      this.wechatDialogVisible = true;
    },
    // 关闭微信弹窗
    getCloseWechat(){
      clearInterval(this.isBindWx);
      this.isBindWx = null;
      this.isRefresh = false;
      this.wechatDialogVisible = false;
      this.getFlowList()
    },
    // 解除微信绑定弹框
    getShowRemoveWechat(flowcodes){
      MessageBox.confirm('确定需要解绑微信吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
            flowcode:flowcodes
        }
        api.UNBINDWX(params).then((res) => {
            if(res.data.status == '200'){
                this.$message.success(res.data.message);
                this.getFlowList()
            }else{
              this.$message.error(res.data.message)
            }
        })
      }).catch(() => {});
    },
    // 查询是否绑定微信
    checkOpenid(unicode){
      api.CHECKOPENID({unicode:unicode}).then((res) => {
        this.indexys += 2;
        // 两分钟后重新刷新
        if (this.indexys >= 120) {
          this.isRefresh = true;
          clearInterval(this.isBindWx);
          this.isBindWx = null;
        }
        if(res.data.status == '200'){
          clearInterval(this.isBindWx);
          this.isBindWx = null;
          this.$message.success(res.data.message);
          this.getCloseWechat();
        }else if(res.data.status != '220'){
          // status为220时为未绑定微信
          clearInterval(this.isBindWx);
          this.isBindWx = null;
          this.isRefresh = true;
          // this.$message.error(res.data.message);
          if(res.data.status == '202'){
            this.wechatDialogVisible = false;
            let binddata = res.data.data;
            if(binddata.type == 1){ //绑定门店归属总部
              this.$confirm(`<p>当前微信已绑定【<i class="orangeColor">${binddata.flowname}</i>】微门店！</p><small class="greyColor">如坚持绑定此微信，请先解绑微信已绑定的微门店！</small>`, 
                '提示', 
                {
                confirmButtonText: '去解绑',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,
                type: 'warning',
                customClass:'mediumBtnMsg'
              }).then(() => {
                this.distributeForm.flowname = binddata.flowname;
                this.querySearch();
              }).catch(() => { });
            }else{//微门店已绑定非当前门店的微门店
              this.$confirm(`<p>当前微信已绑定【<i class="orangeColor">${binddata.type==2?binddata.pflowname:'总部'}</i>】${binddata.type==2?'门店':''}下的【<i class="orangeColor">${binddata.flowname}</i>】微门店！</p><small class="greyColor">如坚持绑定此微信，请先登录【<i class="orangeColor">${binddata.type==2?binddata.pflowname:'总部'}</i>】${binddata.type==2?'门店':''}，解绑微信已绑定的微门店后，方可绑定此微门店！</small>`, 
                '提示', 
                {
                confirmButtonText: '我已了解',
                showCancelButton:false,
                dangerouslyUseHTMLString: true,
                type: 'warning'
              }).then(() => {
              }).catch(() => { });
            }
          }else{
            // this.$message.error(res.data.message);
            this.$alert(`${res.data.message}`, '系统提示', {
              type: 'warning'
            });
          }
        }
      })
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 130;
    },
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted () {
    //在dom渲染之后
    setTimeout(()=>{
      this.getHeight();
    },300);
    this.getFlowList('total');//获取列表
    // 公告服务配置
    if(localStorage.getItem('pubconfiginfo')&&localStorage.getItem('pubconfiginfo')!='null'&&localStorage.getItem('pubconfiginfo')!='undefined') {
        let pubConfigInfo = JSON.parse(localStorage.getItem('pubconfiginfo'));
        this.creappnum = pubConfigInfo.creappnum;
    }else{
        this.creappnum = 5;
    }
  },
  destroyed(){
    window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>

<style scoped>
@import '../Css/style.css';
.mainPart {padding: 20px; height: calc(100% - 50px);}
.wechatAvatar p{
  width:50px;
  height:50px;
  border: solid 1px #dcdfe6;
  border-radius: 100%;
  margin-right: 10px;
  position:relative;
}
.wechatAvatar p img{
  border-radius:100%;
}
.wechatAvatar span{
  display:inline-block;
  width: calc(100% - 65px);
}
/* S 验证弹框 */
.recoverDlog>>>.el-dialog{
    width: 420px;
}
.recoverDlog>>>.el-dialog__footer{
    box-shadow: none;
    margin-bottom: 5px;
}
.recoverDlog>>>.el-button{
    padding: 8px 15px;
}
.recoverDlog p{
    color: #666;
    line-height: 25px;
}
.recoverDlog>>>.el-dialog__body{
    padding: 13px 20px 11px 20px;
}
.recoverDlog>>>.el-textarea{
    margin-top: 15px;
}
.el-icon-warning,
.el-icon-success{
    color: #F2962C;
    font-size: 24px;
    margin-right: 15px;
}
.el-icon-success{
  color:#67C23A;
}
.imgCon{
  width:300px;
  height:300px;
  position:relative;
  margin:0 auto;
}
/* E 验证弹框 */
.cover{
  background: rgba(0,0,0,.6);
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.cover span{
  position: absolute;
  -ms-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  top: 50%;
  text-align: center;
  left: 0;
  right: 0;
  margin: auto;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}
.breathTit{
  line-height: 40px;
  font-size: 13px;
}
.breathTit i{margin: 0 5px;font-weight: bold;}
</style>




// WEBPACK FOOTER //
// src/views/ManageFolder/PlatformUser/CompanyStore.vue